import { useEffect } from 'react';
import { setTitleActions } from '@iso/containers/Dashboard/titleActionsStore';

/**
 * Ações da tela na BARRA DE TÍTULO (ícones flutuantes na linha inferior).
 *
 * Uso:
 *   <PageTitleActions
 *     primary={{ key: 'new', label: 'Adicionar produto', icon: <PlusOutlined />, onClick: criar }}
 *     more={[
 *       { key: 'selectAll', label: 'Selecionar todos', icon: <CheckSquareOutlined />, onClick: ... },
 *       { key: 'clear', label: 'Limpar seleção', onClick: ... },
 *     ]}
 *   />
 *
 * `primary` vira o botão redondo principal ("+"); `more` alimenta o "..." (cascata).
 * Não desenha nada aqui: quem desenha é a barra de título fixa.
 */
export default function PageTitleActions({ primary, more }) {
	useEffect(() => {
		const list = more || [];
		const hasActions = !!primary || list.length > 0;
		setTitleActions(hasActions ? { primary: primary || null, more: list } : null);
		return () => setTitleActions(null);
	}, [primary, more]);

	return null;
}
